import { Helmet } from "react-helmet";
import React from "react";
import SEO from "../utils/SEO.json";
import { memo } from "react";
import { useGlobalSearchParams } from "expo-router";
import { useSegments } from "expo-router";

const SEOWrapper = (props) => {
    const global = useGlobalSearchParams();
    const segments = useSegments()[0];
    let gender = global?.gender && global?.gender !== "undefined" ? global?.gender : "";

    const optionId = global?.optionId || null;
    let title = global.title || "";
    let page = segments || `home ${gender.replace("female", "Women").replace("male", "Men")}`;
    const product = global.product || "";
    const filterObj =  "";
    let subCategoryTitle = "";
    const selectedSubCategory = filterObj?.selected?.[1];
    if (selectedSubCategory) {
        subCategoryTitle = ": ";
        selectedSubCategory.forEach((item) => {
            subCategoryTitle += `${item.title} | `;
        });
    }

    if (optionId) {
        page = "New Arrivals";
    }
    if (page == "designers") {
        page = `designers ${gender.replace("female", "Women").replace("male", "Men")}`;
    }

    const ignorePageTitle = Object.keys(SEO.pages);
    const seoData = SEO.pages[page] || SEO;
    const dynamicTitle = seoData.title;
    let dynamicDescription = seoData.description;
    const dynamicKeywords = seoData.keywords;

    const sanitizeContent = (content) => {
        if (!content) return '';
        return String(content)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;')
            .replace(/\//g, '&#x2F;');
    };

    // Sanitize all dynamic content
    const sanitizedTitle = sanitizeContent(title);
    const sanitizedProduct = sanitizeContent(product);
    const sanitizedSubCategoryTitle = sanitizeContent(subCategoryTitle);
    const sanitizedDynamicTitle = sanitizeContent(dynamicTitle);
    dynamicDescription = `${sanitizedTitle.slice(0, 15)}  ${dynamicDescription}`;
    const sanitizedDynamicDescription = sanitizeContent(dynamicDescription ? dynamicDescription : "Explore the newest in luxury designer collections for women's fashion, accessories, and beauty.");
    const sanitizedDynamicKeywords = sanitizeContent(dynamicKeywords);
    

    return (
        <>
            <Helmet>
                <title>
                    {`${sanitizedProduct ? `${sanitizedProduct} | ` : ""}${sanitizedTitle ? `${sanitizedTitle.charAt(0).toUpperCase() + sanitizedTitle.slice(1)} ` : ""}${sanitizedSubCategoryTitle}${ignorePageTitle.includes(page) ? "" : `${page.replace("-", " ").charAt(0).toUpperCase() + page.replace("-", " ").slice(1)} | `}${sanitizedDynamicTitle}${gender && gender !== "both" ? ` | ${gender.replace("female", "Women").replace("male", "Men")}` : ""}`}
                </title>
                
                <meta name="description" content={`${dynamicDescription} | ${gender.replace("female", "Women").replace("male", "Men")}`}  />
                <meta name="keywords" content={`${sanitizedDynamicKeywords} , ${gender.replace("female", "Women").replace("male", "Men")}` } />
                <link rel="canonical" href={window.location.href} />                  
                <meta name="google-site-verification" content="fq6sQ-kPZDfE6BTCcw8OWFBniXTWhIbm319cJGgUXH4" />
                {/* <meta httpEquiv="Content-Security-Policy" content="default-src 'self' https://*.vetirapp.com; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.jsdelivr.net https://cdnjs.cloudflare.com https://appleid.apple.com https://appleid.cdn-apple.com https://*.firebaseio.com https://*.firebase.com https://*.google.com https://*.googleapis.com https://www.googletagmanager.com; style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; img-src 'self' data: https: blob:; font-src 'self' https://fonts.gstatic.com; connect-src 'self' https://*.vetirapp.com https://api.ipify.org https://appleid.apple.com https://*.firebaseio.com https://*.firebase.com https://*.google.com https://*.googleapis.com https://*.sentry.io wss://*.firebaseio.com; frame-src 'self' https://appleid.apple.com https://*.google.com; media-src 'self' blob: https:; object-src 'none'; base-uri 'self'; form-action 'self'; worker-src 'self' blob:;" /> */}



                {/* <link rel="canonical" href="https://vetirapp.com" /> */}
                <meta httpEquiv="X-Frame-Options" content="SAMEORIGIN" />
                <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
                <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />

                {/* Twitter Card Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@vetirapp" />
                <meta name="twitter:title" content={sanitizedDynamicTitle.slice(0, 65)} />
                <meta name="twitter:description" content={sanitizedDynamicDescription.slice(0,155)} />
                <meta name="twitter:image" content="https://vetirapp.com/favicon.ico" />
                <meta name="twitter:image:alt" content={sanitizedDynamicTitle.slice(0, 65)} />
                <meta name="twitter:url" content="https://vetirapp.com" />
                <meta name="robots" content="index,follow" />
                <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
                <meta httpEquiv="Strict-Transport-Security" content="max-age=31536000; includeSubDomains" />
                <meta httpEquiv="Permissions-Policy" content="geolocation=(self)" />
                <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Vêtir",
                        "url": "https://vetirapp.com",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "https://vetirapp.com/search?q={search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    })}
                </script>
            </Helmet>
            {props.children}
        </>
    );
};

export default memo(SEOWrapper);
